(function () {
  if (!window.Element || typeof Element.prototype.animate !== 'function') return;

  var SELECTOR = '.ifaq-details, .tc-faq__i, .bfaq__item, .ctf-faq-item, .ap-acc__i, .ap-extras, .ppf-acc__i, .ppf-extras, .pdp-techsheets, .pdocacc, .footer-new__details';
  var DURATION = 260;
  var EASING = 'cubic-bezier(0.32, 0.08, 0.24, 1)';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function panels(details) {
    var list = [];
    var node = details.firstElementChild;
    while (node) {
      if (node.tagName !== 'SUMMARY') list.push(node);
      node = node.nextElementSibling;
    }
    return list;
  }

  function heightAt(details, open) {
    var wasOpen = details.open;
    var inline = details.style.height;
    details.style.height = 'auto';
    details.open = open;
    var value = details.getBoundingClientRect().height;
    details.open = wasOpen;
    details.style.height = inline;
    return value;
  }

  function stop(details) {
    var running = details._accordion;
    if (!running) return;
    details._accordion = null;
    running.forEach(function (animation) { animation.cancel(); });
  }

  function play(details) {
    var opening = !details.open;
    stop(details);

    var from = details.getBoundingClientRect().height;
    var to = heightAt(details, opening);

    if (Math.abs(to - from) < 1) {
      details.open = opening;
      return;
    }

    details.open = true;
    var overflow = details.style.overflow;
    details.style.overflow = 'hidden';

    var height = details.animate(
      { height: [from + 'px', to + 'px'] },
      { duration: DURATION, easing: EASING, fill: 'both' }
    );
    var running = [height];

    panels(details).forEach(function (panel) {
      running.push(panel.animate(
        { opacity: opening ? [0, 1] : [1, 0] },
        { duration: opening ? 190 : 140, easing: 'linear', fill: 'both' }
      ));
    });

    details._accordion = running;

    height.onfinish = function () {
      if (details._accordion !== running) return;
      details._accordion = null;
      details.open = opening;
      details.style.overflow = overflow;
      running.forEach(function (animation) { animation.cancel(); });
    };
  }

  document.addEventListener('click', function (event) {
    if (reduced.matches) return;
    var target = event.target;
    if (!target || !target.closest) return;
    var summary = target.closest('summary');
    if (!summary) return;
    var details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS' || !details.matches(SELECTOR)) return;
    event.preventDefault();
    play(details);
  }, true);
})();
